import clevertap from "clevertap-web-sdk";
import { useEffect, useState } from "react";
import HighlightedText from "react-highlight-words";

//assets
import { SvgArrowDown } from "assets/icons/js/SvgArrowDown";

//helpers
import compareStrings from "helpers/compareString";

// styles
import "./style.scss";

const Collapse = (
	{ header, children, query = "", flag = false, theme = {} },
	...props
) => {
	const [open, setOpen] = useState(flag);
	const [animation, setAnimation] = useState({});

	//animations on open and close
	useEffect(() => {
		if (open) setAnimation({ opacity: 1, position: "relative" });
		else {
			setAnimation({ opacity: 0, position: "absolute" });
		}
	}, [open]);

	//opening if the search query is included in children
	useEffect(() => {
		if (compareStrings(children, query) && query.length > 1) {
			clevertap.event.push("faqsearch_listing_page", {
				lisiting_location: window.location.pathname,
				faq_query: query,
				timestamp: new Date(),
			});
			setOpen(true);
		} else setOpen(false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [query]);

	return (
		<div
			className="collapse-wrapper"
			itemprop="mainEntity"
			itemscope=""
			itemtype="http://schema.org/Question"
			style={{
				borderBottomColor: theme?.name === "xseries" && theme?.lineColor,
			}}
		>
			<div
				className={"header-collapse sub-heading-bold "}
				onClick={() => setOpen(!open)}
			>
				<h3
					className={
						`header-collapse-span ${
							theme?.background === "rgba(0, 0, 0, 1)"
								? "x-series-collapse"
								: ""
						}`
						// + (open ? "clr-black" : "clr-grey")
					}
					itemprop="name"
				>
					<HighlightedText
						highlightClassName="highlighted-text"
						searchWords={[...query.split(" ")]}
						autoEscape={true}
						textToHighlight={header}
					/>
				</h3>
				<SvgArrowDown
					style={{
						stroke: theme?.background === "rgba(0, 0, 0, 1)" ? "white" : "",
						transform: open && "rotate(180deg)",
					}}
				/>
			</div>
			<div
				itemprop="acceptedAnswer"
				itemscope=""
				itemtype="http://schema.org/Answer"
			>
				<div
					className="collapse-body text-sm-light"
					style={{ ...animation, color: theme?.baseTextColor }}
					itemprop="text"
				>
					<HighlightedText
						highlightClassName="highlighted-text"
						searchWords={[...query.split(" ")]}
						autoEscape={true}
						textToHighlight={children}
					/>
				</div>
			</div>
		</div>
	);
};

export default Collapse;
